import { render, staticRenderFns } from "./InstallPluginsAndThemes.vue?vue&type=template&id=22ebb832&scoped=true&"
import script from "./InstallPluginsAndThemes.vue?vue&type=script&lang=js&"
export * from "./InstallPluginsAndThemes.vue?vue&type=script&lang=js&"
import style0 from "./InstallPluginsAndThemes.vue?vue&type=style&index=0&id=22ebb832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ebb832",
  null
  
)

export default component.exports